export default function getBetReply(obj: any, toFix: number | 2) {
  const {
    bet_id,
    client_seed,
    server_seed_SHA256,
    server_seed,
    nonce,
    betAmount,
    winCoef,
    winAmount,
    currency,
  } = obj

  const BET_ID = {
    title: 'BET ID',
    content: bet_id,
  }
  const BET_INFO = [
    {
      title: 'BET',
      content: betAmount && (+betAmount).toFixed(toFix) + ' ' + currency,
    },
    {
      title: 'PAYOUT',
      content: winCoef === 0 ? '0.00 X' : winCoef + 'X',
    },
    {
      title: 'WIN',
      content:
        winAmount === 0
          ? '0.00 ' + currency
          : (+winAmount).toFixed(toFix) + ' ' + currency,
    },
  ]
  const SEED = [
    {
      title: 'Clients seed',
      content: client_seed,
    },

    server_seed != ''
      ? {
          title: 'Server seed',
          content: server_seed,
        }
      : {
          title: 'Server seed hash',
          content: server_seed_SHA256,
        },

    {
      title: 'Nonce',
      content: nonce,
    },
  ]
  return { SEED, BET_ID, BET_INFO }
}
